module.exports = __webpack_public_path__ + "img/categorie-huitres-famille-boutrais-big.c50ea99c.jpg";